import { ArrowLeft, Mail, Phone, MapPin, Clock, MessageCircle } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import './Legal.css'

export default function Contact() {
  return (
    <div className="legal-page">
      <Header />
      
      <main className="legal-content">
        <div className="container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="legal-card">
            <h1>Contact Us</h1>
            <p className="legal-intro">We'd love to hear from you!</p>
            <p className="legal-date">Get in touch with us for any questions or support.</p>
            
            <div className="contact-grid">
              <div className="contact-item">
                <div className="contact-icon">
                  <Mail size={24} />
                </div>
                <div className="contact-details">
                  <h3>Email</h3>
                  <a href="mailto:support@santhoshsharuk.me">support@santhoshsharuk.me</a>
                  <p>We'll respond within 24 hours</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <Phone size={24} />
                </div>
                <div className="contact-details">
                  <h3>Phone</h3>
                  <a href="tel:+918110960489">+91 81109 60489</a>
                  <p>Mon-Sat, 10AM - 6PM IST</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <MessageCircle size={24} />
                </div>
                <div className="contact-details">
                  <h3>WhatsApp</h3>
                  <a href="https://wa.me/918110960489" target="_blank" rel="noopener noreferrer">+91 81109 60489</a>
                  <p>Quick responses on WhatsApp</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="contact-icon">
                  <Clock size={24} />
                </div>
                <div className="contact-details">
                  <h3>Business Hours</h3>
                  <p>Monday - Saturday</p>
                  <p>10:00 AM - 6:00 PM IST</p>
                </div>
              </div>
            </div>
            
            <section className="legal-section" style={{ marginTop: '32px' }}>
              <h2>Business Address</h2>
              <div className="address-block">
                <MapPin size={20} />
                <div>
                  <p><strong>Digital vCard</strong></p>
                  <p>Chennai, Tamil Nadu</p>
                  <p>India - 600001</p>
                </div>
              </div>
            </section>
            
            <section className="legal-section">
              <h2>Support</h2>
              <p>
                For technical support, billing inquiries, or general questions about our 
                digital vCard services, please reach out via email or WhatsApp. We're here 
                to help you get the most out of your digital business card.
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}
